exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-team-suggestions-js": () => import("./../../../src/pages/team/suggestions.js" /* webpackChunkName: "component---src-pages-team-suggestions-js" */),
  "component---src-templates-index-page-js": () => import("./../../../src/templates/index-page.js" /* webpackChunkName: "component---src-templates-index-page-js" */),
  "component---src-templates-virtual-page-js": () => import("./../../../src/templates/virtual-page.js" /* webpackChunkName: "component---src-templates-virtual-page-js" */)
}

